// @ts-nocheck
import {
  ADD_AIRPORT_FAILURE,
  ADD_AIRPORT_REQUEST,
  ADD_AIRPORT_SUCCESS,
  DELETE_AIRPORT_FAILURE,
  DELETE_AIRPORT_REQUEST,
  DELETE_AIRPORT_SUCCESS,
  FETCH_AIRPORTS_FAILURE,
  FETCH_AIRPORTS_REQUEST,
  FETCH_AIRPORTS_SUCCESS,
  TOGGLE_AIRPORT_STATUS_FAILURE,
  TOGGLE_AIRPORT_STATUS_REQUEST,
  TOGGLE_AIRPORT_STATUS_SUCCESS,
  UPDATE_AIRPORT_FAILURE,
  UPDATE_AIRPORT_REQUEST,
  UPDATE_AIRPORT_SUCCESS,
} from "../../constants/config/manageAirport";

const initialState = {
  airports: [],
  isLoading: false,
  searchString: "",
  statusLoader: false,
  totalPages: 0,
  currentPage: 1,
  addLoading: false,
};

const manageAirportReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_AIRPORTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload,
      };

    case FETCH_AIRPORTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case FETCH_AIRPORTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        airports: action?.payload?.data,
        totalPages: action?.payload?.totalPages,
        currentPage: action?.payload?.currentPage,
      };

    // NOTE: add airport
    case ADD_AIRPORT_REQUEST:
      return {
        ...state,
        addLoading: true,
      };

    case ADD_AIRPORT_FAILURE:
      return {
        ...state,
        addLoading: false,
      };

    case ADD_AIRPORT_SUCCESS:
      return {
        ...state,
        addLoading: false,
      };

    // NOTE: update airport
    case UPDATE_AIRPORT_REQUEST:
      return {
        ...state,
        addLoading: true,
      };

    case UPDATE_AIRPORT_FAILURE:
      return {
        ...state,
        addLoading: false,
      };

    case UPDATE_AIRPORT_SUCCESS:
      return {
        ...state,
        addLoading: false,
      };

    // NOTE: delete airport
    case DELETE_AIRPORT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case DELETE_AIRPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case DELETE_AIRPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // NOTE: toggle airport status
    case TOGGLE_AIRPORT_STATUS_REQUEST:
      return {
        ...state,
        statusLoader: true,
      };

    case TOGGLE_AIRPORT_STATUS_FAILURE:
      return {
        ...state,
        statusLoader: false,
      };

    case TOGGLE_AIRPORT_STATUS_SUCCESS:
      return {
        ...state,
        statusLoader: false,
        airports: state?.airports?.map((item) => {
          if (item?._id === action?.payload) {
            return {
              ...item,
              status: !item?.status,
            };
          } else {
            return item;
          }
        }),
      };

    default:
      return state;
  }
};

export default manageAirportReducer;